export default "__VITE_ASSET__Bug28QP$__"